import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "animate.css";

function Home()
{
    const [font, setFont] = useState("");
    const [index, setIndex] = useState(0);
    const font_arr = ["f1", "f2", "f3", "f4", "f5"];

    const navigate = useNavigate();

    // useEffect(()=>
    // {
    //     const interval = setInterval(()=>
    //     {
    //         setIndex((prev) => (prev + 1) % font_arr.length);
    //     }, 2000);

    //     return () => 
    //     {
    //         clearInterval(interval);
    //     };

    // }, [font_arr.length])

    useEffect(() => {
        setFont(font_arr[4]);
    }, [index]);
    
    return(
        <div className="content-container">  
            <div className="home-container animate__animated animate__slideInUp">
                <div className="arrow-container">
                    <img className="arrow-point" src="images/arrow-Photoroom.png"></img>
                    <p className="click-this name-this">(how my doctor writes my name lol)</p>
                </div>
                
                <h1><span className={font} onClick={() => navigate("/about")}>John Dimelu</span> <br/>is a <Link to="/full-stack" className="choose-adv">front-end developer</Link> by <br /> day and an <Link to="/creative" className="choose-adv">all out creative</Link> by <br /> night.</h1>

                <div className="click-container">
                    <img className="arrow-point2" src="images/arrow-Photoroom.png"></img>
                    <p className="click-this"> click any of my trades :)</p>
                </div>
                
                
                <img className="glasses-one" src="images/logoR.png" alt="logo-animation-frame"></img>
                <img className="glasses-two" src="images/logoL.png" alt="logo-animation-frame"></img>
            </div>
        </div>
    )
}

export default Home;